module.exports = __webpack_public_path__ + "img/badtag_txt.c61e9fba.png";